'use client';

import { Autocomplete, TextField } from '@mui/material';

export type ShippingTypeSelectProps = {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  label?: string;
  required?: boolean;
};

/** Carrier/service dropdown with optional custom entry (legacy select2 behavior). */
export function ShippingTypeSelect({
  value,
  options,
  onChange,
  disabled = false,
  error = false,
  helperText,
  label,
  required = false,
}: ShippingTypeSelectProps) {
  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value}
      disabled={disabled}
      onChange={(_, newValue) => onChange(newValue ?? '')}
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') {
          onChange(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          fullWidth
          label={label}
          required={required}
          placeholder="Select shipping type"
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
